<template>
    <ValidationObserver v-slot="{ invalid }">
        <v-card :class="{ jsCardHasError: invalid }">
            <v-card-title><v-switch v-model="published" :label="publishedText"></v-switch></v-card-title>
            <v-card-text>
                <form action="" method="POST" @submit.prevent="save">
                    <!-- Professions -->
                    <v-row>
                        <v-col cols="12">
                            <ValidationProvider name="profession">
                                <v-autocomplete
                                    :items="selectableProfessions"
                                    item-text="name"
                                    item-value="id"
                                    name="profession_id"
                                    id="profession_id"
                                    label="Profession"
                                    v-model="profession"
                                    outlined
                                    no-data-text="All professions for the selected field have been populated."
                                ></v-autocomplete>
                            </ValidationProvider>
                        </v-col>
                    </v-row>

                    <!-- Fields -->
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                    v-model="fieldId"
                                    :items="fieldsForSelect"
                                    label="Field"
                                    item-text="name"
                                    item-value="id"
                                    outlined
                            >
                                <template v-slot:item="data">
                                    <template>
                                        <v-list-item-content>
                                            <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                            <v-list-item-subtitle
                                                    v-html="data.item.group"
                                            ></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                    <!--
                    -------------------------------------------------
                    Population Editors
                    -------------------------------------------------
                    -->
                    <v-row v-if="hydrated">
                        <v-col cols="12">
                            <SingleText v-if="fieldType === 'text'"/>
                            <SingleTextarea v-else-if="fieldType === 'textarea'"/>
                            <WYSIWYG v-else-if="fieldType === 'wysiwyg'"></WYSIWYG>
                            <div v-else-if="fieldType === 'group'">
                                <GroupInput></GroupInput>
                            </div>
                            <div v-else>This field does not support populations.</div>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-card-actions>
                <v-btn text @click="toggleDeleteModal(true)" :disabled="invalid">Delete Population</v-btn>
                <v-spacer></v-spacer>
                <v-btn type="submit" color="primary" @click="save">
                    <v-icon left small>fas fa-save</v-icon>
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </ValidationObserver>
</template>

<script>
import { mapMutations, mapActions, mapGetters, mapState } from 'vuex';
import store from '../../../../store/store';
import SingleText from './Fields/SingleText';
import SingleTextarea from './Fields/SingleTextarea';
import WYSIWYG from '@/views/Admin/Config/Population/Fields/WYSIWYG';
import GroupInput from '@/views/Admin/Config/Population/Fields/Groups/GroupInput';

export default {
    components: { WYSIWYG, SingleTextarea, SingleText, GroupInput },
    computed: {
        fieldId: {
            get: function() {
                return store.state.populationEditor.fieldId;
            },
            set: function(value) {
                this.setFieldId(value);
            },
        },

        profession: {
            get: function() {
                return store.state.populationEditor.profession;
            },
            set: function(value) {
                this.setProfession(value);
            },
        },

        published: {
            get: function() {
                return store.state.populationEditor.published;
            },
            set: function(value) {
                this.setPublished(value);
            },
        },

        ...mapState('populationEditor', [
            'fields',
            'fieldsForSelect',
            'professions',
            'stepName',
            'stepId',
            'sectionName',
            'sectionId',
            'cardName',
            'cardId',
            'fieldName',
            'fieldType',
            'fieldOptions',
            'deleteModal',
            'hydrated',
            'populations'
        ]),

        ...mapGetters({
            publishedText: 'populationEditor/publishedText',
            selectableProfessions: 'populationEditor/selectableProfessions'
        }),
    },

    watch: {
        fieldId() {
            this.setupField();
        },
    },

    destroyed() {
        this.setHydrated(false);
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            saveData: 'populationEditor/saveData',
            destroyData: 'populationEditor/destroyData',
        }),

        ...mapMutations({
            toggleOverlay: 'overlay/toggle',
            setFieldId: 'populationEditor/setFieldId',
            setProfession: 'populationEditor/setProfession',
            setPublished: 'populationEditor/setPublished',
            setFieldName: 'populationEditor/setFieldName',
            setFieldType: 'populationEditor/setFieldType',
            setFieldOptions: 'populationEditor/setFieldOptions',
            toggleDeleteModal: 'populationEditor/toggleDeleteModal',
            setHydrated: 'populationEditor/setHydrated'
        }),

        save() {
            this.saveData();
        },

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        },

        setupField(){
            const field = this.fields.find(field => field.id === this.fieldId);
            this.setFieldName(field.name);
            this.setFieldType(field.type);
            this.setFieldOptions(field.options);
            this.setFieldId(this.fieldId);
        }
    },
};
</script>
